import { IsPlanDowngradeDisabledParams } from './plan-downgrade.types';

export const isPlanDowngradeDisabled = ({
  selectedPlanProfiles,
  selectedPeriod,
  activeSubscription,
}: IsPlanDowngradeDisabledParams): boolean => {
  if (!activeSubscription) {
    return false;
  }

  if (activeSubscription.period === 'month') {
    if (selectedPeriod !== 'month') {
      return false;
    }

    return selectedPlanProfiles < activeSubscription.profiles;
  }

  if (selectedPeriod === 'month') {
    return true;
  }

  return selectedPlanProfiles < activeSubscription.profiles;
};
